export default function CarouselSection() {
  const items = [
    {
      title: '暑期档热映大片专题',
      desc: '精选国内外最新上映的热门大片，高清画质，中文字幕同步更新，让你足不出户享受影院级观影体验。',
      tag: '热映推荐',
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20montage%20with%20warm%20golden%20theater%20spotlight%2C%20film%20reel%20texture%20overlay%2C%20dramatic%20blockbuster%20atmosphere%2C%20dark%20theater%20background%20with%20warm%20amber%20accents%2C%20luxurious%20cinema%20aesthetic%2C%20elegant%20composition%2C%20no%20text%2C%20rich%20contrast&width=1200&height=600&seq=carousel-1-summer-movies&orientation=landscape',
    },
    {
      title: '高分华语剧集精选',
      desc: '口碑炸裂的国产精品剧一网打尽，从古装传奇到现代都市，每日追更不间断，热门剧集全集放送。',
      tag: '剧集专区',
      img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20visual%20montage%20with%20traditional%20elements%2C%20warm%20lantern%20glow%2C%20silk%20textures%2C%20cinematic%20lighting%20with%20soft%20golden%20tones%2C%20artistic%20composition%2C%20dark%20background%20with%20rich%20warm%20highlights%2C%20no%20text&width=1200&height=600&seq=carousel-2-chinese-drama&orientation=landscape',
    },
    {
      title: '日韩热门剧集速递',
      desc: '最新日韩电视剧同步更新，热门韩剧、经典日剧、人气综艺一应俱全，字幕组精心译制。',
      tag: '海外剧场',
      img: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20drama%20visual%20style%20with%20soft%20romantic%20atmosphere%2C%20cherry%20blossom%20elements%2C%20warm%20cityscape%20twilight%2C%20cinematic%20composition%20with%20gentle%20golden%20lighting%2C%20elegant%20soft%20focus%2C%20dark%20background%20accents%2C%20no%20text&width=1200&height=600&seq=carousel-3-korean-japanese&orientation=landscape',
    },
    {
      title: '经典老片修复重温',
      desc: '那些年的银幕经典高清修复版，从港片黄金时代到好莱坞不朽传奇，重温光影记忆中的感动瞬间。',
      tag: '经典回顾',
      img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20classic%20movie%20elements%2C%20old%20Hollywood%20glamour%2C%20warm%20sepia%20and%20gold%20tones%2C%20film%20grain%20texture%2C%20elegant%20theater%20curtain%20drape%2C%20nostalgic%20cinematic%20atmosphere%2C%20dark%20rich%20background%2C%20no%20text&width=1200&height=600&seq=carousel-4-classic-films&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选影视专题，每周更新推荐内容，助你发现更多精彩好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {items.map((item, i) => (
            <article
              key={i}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 md:h-64 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}